module.exports = __webpack_public_path__ + "static/media/wave-test.3222fe66.svg";